/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ServicedeskKnowledgeHubViewArticleType from '@jira/spa-apps__servicedesk-knowledge-hub-view-article/src/ServicedeskKnowledgeHubViewArticle.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyServicedeskKnowledgeHubViewArticle: LazyComponent<() => React.JSX.Element> =
	lazyForPaint<typeof ServicedeskKnowledgeHubViewArticleType>(() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-servicedesk-knowledge-hub-view-article", jiraSpaEntry: "async-servicedesk-knowledge-hub-view-article" */ '@jira/spa-apps__servicedesk-knowledge-hub-view-article/src/ServicedeskKnowledgeHubViewArticle.tsx'
			),
		),
	);

const AsyncServicedeskKnowledgeHubViewArticle = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskKnowledgeHubViewArticle}
		pageId="spa-apps/servicedesk/knowledge-hub/view-article"
		shouldShowSpinner
	/>
);

export default AsyncServicedeskKnowledgeHubViewArticle;
